<template>
  <nav>
    <v-app-bar 
      v-if="currentRoute !== 'signin'" 
      flat 
      app 
      clipped-left 
      :color="bannerColor">
      <v-app-bar-nav-icon 
        large 
        class="white--text"
        @click="drawer = !drawer" />
      <v-spacer />
      <div class="text-h6 white--text">{{ $route.name }}</div>
      <v-spacer />
      <v-icon
        v-if="environment !== 'production'" 
        large
        class="white--text flashing-icon"
        :class="isOnline ? 'mr-4' : ''">
        mdi-dev-to
      </v-icon>
       <v-icon 
          v-show="!isOnline" 
          class="mx-4 white--text" 
          large>
          mdi-cloud-off-outline
        </v-icon>
    </v-app-bar>

    <v-navigation-drawer 
      v-if="currentRoute !== 'signin'" 
      v-model="drawer" 
      app 
      clipped>
      <v-container>
        <v-row>
          <v-col>
            <v-card 
              width="300" 
              color="transparent" 
              flat>
              <div style="text-align: center;">
                <img 
                  style="vertical-align: middle;" 
                  src="@/assets/img/gba-logox96.png" 
                  alt="Genomic Bleed Logo" />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-list style="padding: 0;">
        <v-list-item 
          v-for="link in links"
          :key="link.text" 
          :to="link.route" 
          :disabled="link.disabled"
          :exact="link.exact">
          <v-list-item-icon class="mr-4">
            <v-icon :class="link.indent ? 'ml-10': ''" :disabled="link.disabled">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav> 
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      drawer: false,
      environment: null
    }
  },
  created() {
    this.environment = process.env.VUE_APP_MODE;
  },
  computed: {
    ...mapState(['settings','isOnline']),
    currentRoute() {
      return this.$route.name;
    },
    bannerColor() {
      if (this.$route.name.includes('Genomic Bleed', 'Genomic Bleeds')) 
        return 'tertiary';
      if (this.$route.name.includes('Genomic Check', 'Genomic Checks')) 
        return 'success';
      else if (this.$route.name.includes('Health Bleed', 'Health Bleeds'))
        return 'secondary';
      else
      return 'primary';
    },
    links() {
      let links = [
        { icon: "mdi-home", text: 'Home', route: "/", disabled: false, exact: true },
        { icon: "mdi-dna", text: 'Genomic Bleed', route: "/genomicbleed", disabled: false, exact: true } 
      ];

      if (this.settings.isGenomicCheckEnabled) {
        links = [...links, 
          { icon: "mdi-check-decagram-outline", text: 'Genomic Check', route: {name: 'Genomic Check', params:{check:true}}, disabled: false, exact: true }
        ];
      }

      links = [...links,
        { icon: "mdi-medical-bag", text: 'Health Bleed', route: "/healthbleed", disabled: false, exact: true },
        { icon: "mdi-database", text: 'Local Storage', route: "/localstorage", disabled: false, exact: true },
        { icon: "mdi-file-document-multiple", text: 'Documents', route: "/documents", disabled: false, exact: true },
        { icon: "mdi-cog", text: 'Settings', route: "/settings", disabled: false, exact: true }
      ];
      
      return links;
    }
  }
};
</script>

<style scoped>
  img.nav-icon:hover {
    cursor: pointer;
  }

  @keyframes flash {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }

  .flashing-icon {
    animation: flash 1s infinite;
  }
</style>